import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login'
import MainPage from '@/view/main'
import UserList from '@/view/userList'
import MWSearch from '@/view/mwSearch'
import TerminalManager from '@/view/terminalManager'
import Company from "@/view/company"
import RegisterTerminal from "@/view/registerTerminal"
import QRPrinter from "@/view/QRPrinter"
import DriverList from "@/view/driverList"
import Waiting from "@/view/wait"
import CarList from "@/view/carList"
import AreaList from "@/view/area"
import LineList from "@/view/lineList"
import CarOut from "@/view/outRec"
import CarOutHistory from "@/view/outHistory"
import QRCode from "@/view/qrCode"


import Report from "@/view/report"
import Grant from "@/view/report/grant"
import Grant1 from "@/view/report/grant1"
import GrantSum from "@/view/report/grantSum"
import Month from "@/view/report/month"
import Month1 from "@/view/report/month1"
import Dangerous from "@/view/report/dangerous"
import Year from "@/view/report/year"
import Transfer from "@/view/report/transfer"
import InOut from "@/view/report/in-out"
import In from "@/view/report/in"
import Out from "@/view/report/out"
import TransshipmentSheet from "@/view/TransshipmentSheet"
import TerminalData from "@/view/terminalData"

import StatisticsByDay from "@/view/StatisticsByDay"

import MyTransport from "@/view/myTransport"
import MyTransshipmentSheet from "@/view/MyTransshipmentSheet"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:"/",
      name:"login",
      component:Login
    },
    {
      path:"/qr",
      name:"QRCode",
      component:QRCode
    },
    {
      path: "/report/grant",
      name: "Grant",
      component: Grant,

    },
    {
      path: "/report/grantSum",
      name: "GrantSum",
      component: GrantSum,

    },
    {
      path: "/report/month",
      name: "Month",
      component: Month
    },
    {
      path: "/report/dangerous",
      name: "Dangerous",
      component: Dangerous,
    },
    {
      path: "/report/year",
      name: "Year",
      component: Year,
    },
    {
      path: "/report/month1",
      name: "Month1",
      component: Month1,
    },
    {
      path: "/report/grant1",
      name: "Grant1",
      component: Grant1,
    },
    {
      path: "/report/transfer",
      name: "Transfer",
      component: Transfer,
    },
    {
      path: "/report/in-out",
      name: "InOut",
      component: InOut,
    },
    {
      path: "/report/in",
      name: "In",
      component: In,
    },
    {
      path: "/report/out",
      name: "Out",
      component: Out,
    },
    {
      path:"/m",
      name:"main",
      component:MainPage,
      children:[
        {
          path:"/m/user_list",
          name:"userList",
          component:UserList
        },
        {
          path:"/m/Transshipment_sheet",
          name:"TransshipmentSheet",
          component:TransshipmentSheet
        },
        {
          path:"/m/mw_search",
          name:"mwSearch",
          component:MWSearch
        },,
        {
          path:"/m/StatisticsByDay",
          name:"StatisticsByDay",
          component:StatisticsByDay
        },
        {
          path:"/m/terminal_manager",
          name:"TerminalManager",
          component:TerminalManager
        },
        {
          path:"/m/terminal_data",
          name:"TerminalData",
          component:TerminalData
        },
        {
          path:"/m/company",
          name:"Company",
          component:Company
        },
        {
          path:"/m/registerTerminal",
          name:"RegisterTerminal",
          component:RegisterTerminal
        },
        {
          path:"/m/qr_printer",
          name:"QRPrinter",
          component:QRPrinter
        },
        {
          path:"/m/driver_list",
          name:"DriverList",
          component:DriverList
        },
        {
          path:"/m/wait",
          name:"Waiting",
          component:Waiting
        },
        {
          path:"/m/car_list",
          name:"CarList",
          component:CarList
        },
        {
          path:"/m/area",
          name:"AreaList",
          component:AreaList
        },
        {
          path:"/m/line",
          name:"LineList",
          component:LineList
        },
        {
          path:"/m/car_out_list",
          name:"CarOut",
          component:CarOut
        },{
          path:"/m/car_out_history",
          name:"CarOutHistory",
          component:CarOutHistory
        },
        {
          path:"/m/report",
          name:"Report",
          component:Report,
        },
        {
          path:"/m/myTransport",
          name:"MyTransport",
          component:MyTransport,
        },
        {
          path:"/m/myTransshipmentSheet",
          name:"MyTransshipmentSheet",
          component:MyTransshipmentSheet,
        }
      ]

    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js